export const CONTENT_LIBRARY_FILE_LIMIT = 5000;
